import { Box, Button, Card } from '@mui/material';
import { styled } from '@mui/material/styles';
import { BRAND_COLORS, alpha } from '../../styles/theme';

export const DropzoneContainer = styled(Box)(({ isDragActive }: { isDragActive: boolean }) => ({
  border: `2px dashed ${
    isDragActive ? BRAND_COLORS.forestGreen.main : alpha(BRAND_COLORS.forestGreen.main, 0.3)
  }`,
  borderRadius: '8px',
  padding: '2rem',
  textAlign: 'center',
  backgroundColor: isDragActive
    ? alpha(BRAND_COLORS.forestGreen.main, 0.05)
    : alpha(BRAND_COLORS.forestGreen.main, 0.02),
  cursor: 'pointer',
  transition: 'all 0.3s ease',
  '&:hover': {
    borderColor: BRAND_COLORS.forestGreen.main,
    backgroundColor: alpha(BRAND_COLORS.forestGreen.main, 0.05),
  },
}));

export const UploadButton = styled(Button)({
  backgroundColor: BRAND_COLORS.forestGreen.main,
  color: BRAND_COLORS.white.main,
  '&:hover': {
    backgroundColor: alpha(BRAND_COLORS.forestGreen.main, 0.8),
  },
});

export const FilePreview = styled(Card)({
  marginTop: '1rem',
  backgroundColor: alpha(BRAND_COLORS.yellow.main, 0.05),
  border: `1px solid ${alpha(BRAND_COLORS.yellow.main, 0.2)}`,
});

export interface FileInfo {
  file: File;
  preview: string;
}
